import cx from 'classnames';
import PropTypes from 'prop-types';
import { useIsGlobetrotter } from '@bwoty-web/ui-kit/hooks';

import InspirationalImages from '../hotelInfo/components/inspirationalImages';

import './PackagePlusMainOptionView.scss';

const PackagePlusMainOptionView = ({
  mainOption: { heading, images, text },
  labels,
}) => {
  const isGlobetrotter = useIsGlobetrotter();

  return (
    <div
      className={cx('geo-package-plus-main-option__container', {
        'geo-package-plus-main-option__container--isGlobetrotter':
          isGlobetrotter,
      })}
    >
      {heading && (
        <h2 className="geo-package-plus-main-option__heading">{heading}</h2>
      )}
      {text && (
        <p className="geo-package-plus-main-option__description">{text}</p>
      )}
      {!!images?.length && (
        <div className="geo-package-plus-main-option__images">
          <InspirationalImages
            images={images.slice(1)}
            imagesCount={images.length}
            isConceptHotel={false}
            isGlobe={isGlobetrotter}
            labels={labels}
            openGallery={() => window.postMessage('cmd.open.gallery')}
          />
        </div>
      )}
    </div>
  );
};

PackagePlusMainOptionView.propTypes = {
  mainOption: PropTypes.shape({
    heading: PropTypes.string,
    images: PropTypes.arrayOf(PropTypes.shape()),
    text: PropTypes.string,
  }),
  labels: PropTypes.shape().isRequired,
};

PackagePlusMainOptionView.defaultProps = {
  mainOption: {},
};

export default PackagePlusMainOptionView;
